var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"20%"}},[_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("登陆中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }